import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { Checkbox } from 'syf-component-library/ui/atoms';
import { t } from '../../translations/getTranslation';
const ItemWrapper = styled.li `
  all: unset;
  padding-top: ${({ theme }) => theme.spacing.xsmall}px;
  padding-bottom: ${({ theme }) => theme.spacing.base}px;
  display: flex;
`;
const HeadingLabel = styled.label `
  font-size: ${({ theme }) => theme.fontSizes.regular}px;
  line-height: ${({ theme }) => theme.lineHeights.small};
  text-transform: capitalize;

  @media ${query.greaterThanMedium} {
    font-size: ${({ theme }) => theme.fontSizes.root}px;
  }
`;
const Subtext = styled.p `
  font-size: ${({ theme }) => theme.fontSizes.small}px;
  line-height: ${({ theme }) => theme.lineHeights.small};
`;
const MainDescription = styled.p `
  margin-top: ${({ theme }) => theme.spacing.small}px;
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.lineHeights.small};

  @media ${query.greaterThanMedium} {
    font-size: ${({ theme }) => theme.fontSizes.root}px;
    line-height: ${({ theme }) => theme.lineHeights.root};
    margin-top: 0;
  }
`;
const AdditionalText = styled.p `
  margin-top: ${({ theme }) => theme.spacing.small}px;
  font-size: ${({ theme }) => theme.fontSizes.small}px;
  font-style: italic;
  line-height: ${({ theme }) => theme.lineHeights.small};

  @media ${query.greaterThanMedium} {
    margin-top: ${({ theme }) => theme.spacing.xsmall}px;
  }
`;
const BodyContainer = styled.div `
  margin-top: ${({ theme }) => theme.spacing.small}px;

  @media ${query.greaterThanMedium} {
    display: flex;
    justify-content: space-between;
  }
`;
const CheckboxContainer = styled.div `
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CustomCheckbox = styled(Checkbox) `
  * {
    margin: 0;
  }

  margin-top: ${({ theme }) => theme.spacing.xsmall}px;
  ${({ $hasError, theme }) => $hasError && `label > div > div {border: 2px solid ${theme.colors.error};}`}
`;
export const CheckItem = ({ headingLabel, subtext, description, additionalText, checkboxProps, hasError }) => {
    return (_jsxs(ItemWrapper, { children: [_jsx(CheckboxContainer, { children: _jsx(CustomCheckbox, Object.assign({ size: 24, "$hasError": hasError }, checkboxProps)) }), _jsxs("div", Object.assign({ style: { flex: 1 } }, { children: [_jsxs(BodyContainer, { children: [_jsxs("div", { children: [_jsx(HeadingLabel, Object.assign({ htmlFor: checkboxProps.id }, { children: headingLabel })), _jsx(Subtext, { children: subtext })] }), description && (_jsx(MainDescription, Object.assign({ "data-testid": "desc" }, { children: description })))] }), additionalText && _jsx(AdditionalText, { children: additionalText })] }))] }));
};
const CheckAllButton = styled.button `
  all: unset;
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.cyanBlue};
  cursor: pointer;

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.cyanBlue};
  }
`;
const ListWrapper = styled.ul `
  all: unset;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.medium}px;

  & li {
    border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};

    &:last-child {
      border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
    }
  }
`;
const CheckList = ({ items, renderItem, onToggleCheckAll, selectAllAnalytics }) => {
    const allChecked = items.every(item => item.checkboxProps.isChecked);
    return (_jsxs(_Fragment, { children: [_jsx(CheckAllButton, Object.assign({ "data-cy": "select-all", onClick: onToggleCheckAll, "data-reason": allChecked ? 'unselect all' : 'select all', "data-analytics": selectAllAnalytics === null || selectAllAnalytics === void 0 ? void 0 : selectAllAnalytics.dataAnalytics, "data-object": selectAllAnalytics === null || selectAllAnalytics === void 0 ? void 0 : selectAllAnalytics.dataObject, "data-type": selectAllAnalytics === null || selectAllAnalytics === void 0 ? void 0 : selectAllAnalytics.dataType }, { children: t(allChecked ? 'common.unselectAll' : 'common.selectAll') })), _jsx(ListWrapper, { children: items.map(item => {
                    if (!item.checkboxProps.id) {
                        return null;
                    }
                    return renderItem(Object.assign(Object.assign({}, item), { key: item.checkboxProps.id }));
                }) })] }));
};
export default CheckList;
//# sourceMappingURL=index.js.map